import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root',
})
export class ProcessTerrainService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/processterrain`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    changeAreaMapForProcess(interventionCode: string, samplingId: number, newProcessAreaMapId: number) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/${interventionCode}/${samplingId}/${newProcessAreaMapId}`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('changeAreaMapForProcess')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    changeProcess(interventionCode: string, sourceSamplingId: number, destinationSamplingId: number, areaMapId: number) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/replace/${interventionCode}/${sourceSamplingId}/${destinationSamplingId}/${areaMapId}`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('changeProcess')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }
}